import {Injectable} from "@angular/core";

import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import { StringUtils } from './utils/StringUtils';
import { SystemApp } from './constans/SystemConfigurations';
import { TokenStore } from './core/auth/token-store';


@Injectable({providedIn: 'root'})

export class ApiUrl{

  constructor(private router: Router, private activeRouter: ActivatedRoute, public http:HttpClient) {}

  private apikTenant = this.getCookie('apiKey')
  private externalURL = this.getCookie('external_apiUrl')

  // JWT-only (Token -> JWT migration complete): the legacy DRF token is no
  // longer read here at all, even as a fallback. Every service in this app
  // builds its Authorization header through getJWTToken(), so this is the
  // one place that had to change to make the whole app JWT-only - see
  // core/auth/auth.interceptor.ts for the 401-refresh side of this.
  public getJWTTokenKey(): string | null{
    return TokenStore.get() || "";
  }
  public getJWTToken(){
    const access = TokenStore.get();
    return access ? 'Bearer ' + access : "";
  }

  public getCookie(cname:string): string{
    const name = cname + "="
    const ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  getSliders(): string {
    return SystemApp.base_url_api + '/api/slider/'
  }

  getColor(): string {
    return SystemApp.base_url_api + '/api/colors/'
  }
  getSize(): string {
    return SystemApp.base_url_api + '/api/sizes/'
  }



  getProducts(mainCategory:string, subCategory:string|null = null): string{
    let url = SystemApp.base_url_api + '/clientAjax/product/?mainCategory=' + mainCategory;
    if(subCategory != null){
      url += "&subCategory="+subCategory;
    }
    return url;
  }

  getPages(): string{
    return SystemApp.base_url_api + '/pages/'
  }

  getCategories(): string {
    return SystemApp.base_url_api + '/api/mainCategory/'
  }

  getBanners(): string {
    return SystemApp.base_url_api + '/api/banners/'
  }



  getProduct(productId:string): string{
    return SystemApp.base_url_api + '/clientAjax/product/' + productId + '/';
  }
  getAdminAdvs(): string{
    return SystemApp.base_url_api + '/myAdmin/advs/';
  }
  getAdminStores(): string {
    return SystemApp.base_url_api + '/myAdmin/store/';
  }
  getStoreByUserToken(): string {
    return SystemApp.base_url_api + '/store/store_info/';
  }

  getStores(): string {
    return SystemApp.base_url_api + '/api/store/';
  }

  loginUser(): string{
    return SystemApp.base_url_api + '/api-token-auth/'
  }

  /** SEC-06 (SCRUM-351): admin second factor - status | setup | confirm | verify */
  adminMfa(step: 'status' | 'setup' | 'confirm' | 'verify'): string {
    return SystemApp.base_url_api + '/api/auth/mfa/' + step + '/'
  }

  getCategory(): string {
    return SystemApp.base_url_api + '/api/mainCategory/';
  }

  getBrands(): string {
    return SystemApp.base_url_api + '/api/brands/';
  }
  getOrder(): string {
    return SystemApp.base_url_api + '/api/orders/';
  }
  getUserDetails(): string {
    return SystemApp.base_url_api + '/api/users/';
  }
  getAllUsers(): string{
    return SystemApp.base_url_api + '/admin-api/users/'
  }
  getAllFloatingNotification(): string{
    return SystemApp.base_url_api + '/notification-api/floating-notifications/'
  }
  getBanner(): string {
    return SystemApp.base_url_api + '/admin-api/banners/';
  }
  getSlider(): string {
    return SystemApp.base_url_api + '/api/slider/';
  }
  getVideo(): string {
    return SystemApp.base_url_api + '/api/video/';
  }

  public getUrlParam(params: string): Observable<any>{
    const a = new Observable(observer => {
      this.activeRouter.queryParams.subscribe(res =>{
        observer.next(res[params])
      });
    })
    return a;
  }


  registerUser(): string{
    return SystemApp.base_url_api + '/api/users/'
  }

  getTopcategory(): string{
    return SystemApp.base_url_api + '/ads/topcategory'
  }

  getCarouselSlider(): string{
    return SystemApp.base_url_api + '/clientAjax/carouselSlider'
  }

  getTopProducts(): string{
    return SystemApp.base_url_api + '/clientAjax/top6products'
  }

  getUserInfo(): string{
    return SystemApp.base_url_api + '/user/user_info/'
  }

  getAds(): string{
    return SystemApp.base_url_api + '/user/user_ads/'
  }

  public getNameSpacePos(delimiter:string, position:number){
    const url = this.router.url
    return url.$piece(delimiter,position)
  }

  public getNameSpace(): string{
    const url = this.router.url
    return url.$piece('/publish/',2)
  }

  getFormsQuestion(namespance: string): string{
    return SystemApp.base_url_api + '/dynamicForm/?namespace='+namespance
  }

  getFormsQuestionUrl(): string{
    return SystemApp.base_url_api + '/clientAjax/adv/publish/'
  }
  getMainCategory(): string{
    return SystemApp.base_url_api + '/clientAjax/mainCategory'
  }
  getSubCategory(nameSpace: string): string{
    return SystemApp.base_url_api + '/clientAjax/subCategory?namespace='+nameSpace;
  }
  getLicenceCarUrl(){
    return SystemApp.base_url_api + '/api/Archive/car/GetCarDescription'
  }
  getCarDescription(producer: string, mainModel: string, year: String): string{
    return SystemApp.base_url_api + '/api/Archive/car/GetCarDescription?codeProducer='+producer+'&mainModel='+mainModel+'&year='+year;
  }
  getBrowserSearch(query: string) {
    return SystemApp.base_url_api + '/clientAjax/browserSearch?q='+query
  }
  getPhoneValidationUrl(): string{
    return SystemApp.base_url_api + '/clientAjax/adv/phone/validation/'
  }

  getFilterBase(namespace: string): string{
    return SystemApp.base_url_api + '/dynamicFilterForms/?namespace=' + namespace;
    // return 'http://localhost:8000/dynamicFilterForms/?namespace=' + namespace;
  }
  private getValue(){

  }


  translateData(object:any, value:string): string{
    const delimiterNum = value.$len("*")
    if(delimiterNum == 0 ){
      const strIndex = value.$piece("*",1)
      return object !=null ? object[strIndex]: null;
    }else{
      for(var i=1; i<=delimiterNum+1 ;i++){
        if(object == null)
          break
        object = object[value.$piece("*", i)]
      }
      return object !=null && object !='' ? object : null;
    }
  }

  getCarFilters(params: any ,arrPram: any){
    arrPram['CodeProducer'] = this.translateData(params, 'codeProducer*label')
    arrPram['MainModel'] = this.translateData(params, 'mainModel*label')
    arrPram['min_year'] = this.translateData(params, 'year*from*label')
    arrPram['max_year'] = this.translateData(params, 'year*to*label')
    arrPram['min_price'] = this.translateData(params, 'price*from')
    arrPram['max_price'] = this.translateData(params, 'price*to')
    arrPram['min_NumberOfOwner'] = this.translateData(params, 'numberOnwer*from*label')
    arrPram['max_NumberOfOwner'] = this.translateData(params, 'numberOnwer*to*label')
    arrPram['gearBox'] = this.translateData(params, 'gearBox*value*value')
    arrPram['min_mileage'] = this.translateData(params, 'mileage*from*label')
    arrPram['max_mileage'] = this.translateData(params, 'mileage*to*label')
    arrPram['CurrentOwner'] = this.translateData(params, 'CurrentOwner*value*value')
    arrPram['Color'] = this.translateData(params, 'color*value*value')
    arrPram['min_engineCapacity'] = this.translateData(params,'engineCapacity*from*label')
    arrPram['max_engineCapacity'] = this.translateData(params,'engineCapacity*to*label')
    return arrPram;
  }

  getNadlanFilters(params: any ,arrPram: any){
    arrPram['entrance'] = this.translateData(params, 'entrance')
    arrPram['sconderyCategory'] = this.translateData(params, 'sconderyCategory*label')
    arrPram['nadlanType'] = this.translateData(params, 'nadlanType*label')
    arrPram['availabilityEntrance'] = this.translateData(params, 'availabilityEntrance')
    arrPram['armatureList'] = this.translateData(params, 'armatureList')
    arrPram['min_Floor'] = this.translateData(params, 'Floor*from*label')
    arrPram['max_Floor'] = this.translateData(params, 'Floor*to*label')
    arrPram['min_numberOfRooms'] = this.translateData(params, 'numberOfRooms*from*label')
    arrPram['max_numberOfRooms'] = this.translateData(params, 'numberOfRooms*to*label')
    arrPram['min_buildingMeter'] = this.translateData(params, 'buildingMeter*from')
    arrPram['max_buildingMeter'] = this.translateData(params, 'buildingMeter*to')
    arrPram['min_price'] = this.translateData(params, 'price*from')
    arrPram['City'] = this.translateData(params, 'City*value*value')
    arrPram['max_price'] = this.translateData(params, 'price*to')
    return arrPram;
  }


  getSale2Filters(params: any ,arrPram: any){
    arrPram['Sale2ThirdCategory_degem'] = this.translateData(params, 'Sale2ThirdCategory_degem*label')
    arrPram['sale2ThirdCategory_thirdCategory'] = this.translateData(params, 'sale2ThirdCategory_thirdCategory*label')
    arrPram['subCategory'] = this.translateData(params, 'subCategory*value*value')
    arrPram['sconderyCategory'] = this.translateData(params, 'sconderyCategory*value*value')
    return arrPram;
  }
  // getFilterBaseUrl(params:any): string{
  //   var arrPram:any = {}
  //
  //   if(params['mainCategory'].toLowerCase() == 'Car'.toLowerCase()){
  //     arrPram = this.getCarFilters(params, arrPram);
  //   }
  //
  //   if(params['mainCategory'].toLowerCase() == 'Nadlan'.toLowerCase()){
  //     arrPram = this.getNadlanFilters(params, arrPram);
  //   }
  //
  //   if(params['mainCategory'].toLowerCase() == 'Sale2'.toLowerCase()){
  //     arrPram = this.getSale2Filters(params, arrPram);
  //   }
  //
  //
  //   const paramArr = Object.keys(arrPram)
  //   let url = "";
  //   paramArr.forEach((key)=>{
  //     url=url+key+"="+arrPram[key]+"&"
  //   })
  //   return SystemApp.base_url_api + '/clientAjax/shop/search/'+params['mainCategory']+'?'+url
  // }

  getFilterBasePostUrl(mainCategory:any, limit:any, offset:any){
    return SystemApp.base_url_api + `/clientAjax/productVFilteriewSet?limit=${limit}&offset=${offset}&model_class=${mainCategory}`
  }
  getAccessories(mainCategoryId: string): string{
    return SystemApp.base_url_api + '/tables/GetArmatureList/?MainCategory=' + mainCategoryId;
  }


  buildPayload(mainCategory:any, subCategory:any, arrJson:any){
    var arrPram:any = {}

    if(arrJson['mainCategory'].toLowerCase() == 'Car'.toLowerCase()){
      arrPram = this.getCarFilters(arrJson, arrPram);
    }

    if(arrJson['mainCategory'].toLowerCase() == 'Nadlan'.toLowerCase()){
      arrPram = this.getNadlanFilters(arrJson, arrPram);
    }

    if(arrJson['mainCategory'].toLowerCase() == 'Sale2'.toLowerCase()){
      arrPram = this.getSale2Filters(arrJson, arrPram);
    }
    return arrPram
  }

  getAdsUrl() {
    return SystemApp.base_url_api + "/clientAjax/productAds/"
  }

  getFixedUrl(url: string):string{
    return SystemApp.base_url_api + '/' + url.replace(/^\/+|\/+$/g, '') + '/';
  }
  getArmatureUrl(){
    return SystemApp.base_url_api + '/admin-api/armatures/'
  }

  generateZCreditSessionUrl() {
  return "https://pci.zcredit.co.il/webcheckout/api/WebCheckout/CreateSession";
  // return SystemApp.base_url_api+ "/clientAjax/zCreditSession/";
  }

  getAdsRouteUrl() {
    return SystemApp.base_url_api + '/admin-api/ads-route/'
  }

  getOrdersUrl() {
    return SystemApp.base_url_api + '/admin-api/orders/'
  }

  getClientAdsRouteUrl() {
    return SystemApp.base_url_api + '/client-api/ads-routes/'
  }

  checkoutAdv(): string {
    return SystemApp.base_url_api + '/client-api/check-out/';
  }
  getLableLanguage() {
    return SystemApp.base_url_api + '/admin-api/label-translate/'
  }
  getDGMCar() {
    return SystemApp.base_url_api + '/admin-api/label-translate/'
  }
  /**
   * SCRUM-153: was misnamed before (it actually returned the *status* URL,
   * not a trigger URL, and wasn't called from anywhere) -- split into the
   * two real endpoints the new admin Processes page uses. Both moved under
   * admin-api/ together with the backend routes themselves.
   */
  getTaskMetadataLatestUrl(){
    return SystemApp.base_url_api + '/admin-api/async-task/taskmetadata/latest/'
  }
  getTriggerAsyncTaskUrl(){
    return SystemApp.base_url_api + '/admin-api/trigger-async-task/'
  }

  getNotificationsUrl(): string{
    return SystemApp.base_url_api + `/notification-api/notifications/`
  }
  getChatRoomsUrl(chatroomId: string|null = null): string{
    const tail = StringUtils.isEmpty(chatroomId) ? '' : `/${chatroomId}`;
    return SystemApp.base_url_api + `/api/chat/chatrooms${tail}`
  }

  getOnlineUsersUrl(): string{
    return SystemApp.base_url_api + `/admin-api/online-users/`
  }

}
